// Cauldron water levels (MB.1 / M9.1). PURE (ENG-1): the fill/drain state
// machine a water cauldron walks. A cauldron holds 0–3 levels of water; an empty
// bucket takes all of it (Java: any non-empty level fills a full bucket), a water
// bucket fills an empty cauldron to the brim, and rain accumulates it a level at
// a time. Lava / powder-snow cauldrons, bottle (⅓-level) fills, dye/banner wash,
// and fire-extinguish are deferred to MB.1-remainder.

export const CAULDRON_MAX = 3;

/** The result of a cauldron interaction: its new level + the item handed back. */
export interface CauldronOp {
  readonly level: number;
  /** Item the interaction leaves in the player's hand (bucket swap). */
  readonly give: string;
}

/**
 * Empty bucket on a cauldron. Java scoops all the water from any non-empty
 * cauldron into a full bucket, leaving it empty. Null on an already-empty one.
 */
export function bucketDrain(level: number): CauldronOp | null {
  return level >= 1 ? { level: 0, give: 'water_bucket' } : null;
}

/**
 * Water bucket on a cauldron. Fills an empty cauldron to the brim, handing back
 * an empty bucket. Null when the cauldron already holds water (no partial top-up
 * from a bucket in Java).
 */
export function bucketFill(level: number): CauldronOp | null {
  return level === 0 ? { level: CAULDRON_MAX, give: 'bucket' } : null;
}

/** One rain-tick accumulation: a sky-exposed cauldron gains a level, capped. */
export function rainAccumulate(level: number): number {
  return Math.min(CAULDRON_MAX, level + 1);
}
